/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

export const EmailEditorTiny = forwardRef(({ initialHtml, onHtmlChange, onFocus, disabled }, ref) => {
  const [content, setContent] = useState(initialHtml || '');
  const editorRef = useRef(null);
  const isInternalChange = useRef(false);

  useEffect(() => {
    if (!isInternalChange.current && initialHtml !== content) {
      setContent(initialHtml || '');
    }
    isInternalChange.current = false;
  }, [initialHtml]);

  const handleChange = newContent => {
    if (disabled) return;

    if (newContent === content) return;

    isInternalChange.current = true;
    setContent(newContent);
    if (onHtmlChange) onHtmlChange(newContent);
  };

  const focusEditor = () => {
    if (disabled) return;
    if (editorRef.current) {
      editorRef.current.focus();
    }
  };

  useImperativeHandle(ref, () => ({
    insertTokenAtCursor: tokenText => {
      if (!editorRef.current) return;

      const editor = editorRef.current;
      const textToInsert = ` ${tokenText}`;

      editor.insertContent(textToInsert);
      editor.focus();
    }
  }));

  const handleEditorInit = (evt, editor) => {
    editorRef.current = editor;
  };

  const handleFocus = () => {
    if (onFocus) onFocus();
  };

  return (
    <div
      onClick={focusEditor}
      style={{
        border: '1px solid #ccc',
        borderRadius: 6,
        marginTop: 4,
        marginBottom: 16,
        overflow: 'hidden',
        minHeight: '500px',
        cursor: disabled ? 'default' : 'text'
      }}
    >
      <Editor
        apiKey="7eho59obowd9a9c1347pvgd9g8tgse6hdqi2elokx8yo7z5i"
        value={content}
        disabled={disabled}
        onInit={handleEditorInit}
        onEditorChange={handleChange}
        onFocus={handleFocus}
        init={{
          height: 500,
          menubar: false,
          plugins: ['code', 'lists', 'link', 'autolink', 'advlist', 'fullscreen', 'table', 'textcolor', 'colorpicker'],
          toolbar:
            'undo redo | formatselect | bold italic underline strikethrough | ' +
            'forecolor backcolor | alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | link | table | code | removeformat',
          content_style: 'body { font-family: Arial, sans-serif; font-size: 14px; white-space: pre-wrap; tab-size: 4; }',
          entity_encoding: 'raw',
          verify_html: false,
          extended_valid_elements: '*[*]',
          valid_children: '+body[style]',
          forced_root_block: 'div',
          force_br_newlines: false,
          force_p_newlines: false,
          preserve_whitespace: true,
          inline_boundaries: false,
          object_resizing: false,
          resize: false,
          statusbar: false,
          branding: false,
          setup: editor => {
            editor.on('keydown', e => {
              if (e.keyCode === 9) {
                e.preventDefault();
                e.stopPropagation();

                if (e.shiftKey) {
                  editor.execCommand('Outdent');
                } else {
                  const node = editor.selection.getNode();
                  if (node.closest('li')) {
                    editor.execCommand('Indent');
                  } else {
                    editor.execCommand('mceInsertContent', false, '&nbsp;&nbsp;&nbsp;&nbsp;');
                  }
                }
                return false;
              }
            });
          },
          table_toolbar:
            'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
          table_default_attributes: {
            border: '1'
          },
          table_default_styles: {
            'border-collapse': 'collapse',
            width: '100%'
          }
        }}
      />
    </div>
  );
});
